import React, { FC, memo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { WaitingButton, Description, Checkbox } from "@evergis/ui";

import { Link } from "components/styled/links/Link";
import { ButtonsContainer, ErrorMessage } from "components/styled/forms";
import { CheckboxesContainer, Desc, TermsDescription } from "./styled";

import { ROUTES } from "../../appConfig";

import { isEmpty } from "../../utils/object";
import { getPortalConfigSelector } from "../../ducks/portalConfig";
import { getMarkdownString } from "../../utils/string";
import { useRegFormSettings } from "../../hooks/useRegFormSettings";
import { useConfigSettings } from "../../hooks/useConfigSettings";

import { IFormFooterProps, IValues } from "./types";

const FormFooterComponent: FC<IFormFooterProps> = ({
  values = {
    email: "",
    username: "",
    password1: "",
    password2: "",
  } as Partial<IValues>,
  error,
  errors,
  isUsernameUnique,
  isEmailUnique,
  isWaiting,
  isSubscribed,
  send,
  toggleSubscribed,
}) => {
  const { t } = useTranslation();
  const config = useSelector(getPortalConfigSelector);
  const { signupByInvite } = useConfigSettings();
  const { email, username, password1, password2 } = values;
  const { signIn, terms } = useRegFormSettings();

  if (!config) {
    return null;
  }

  const hasCommonDisabled = !isEmpty(errors) || email === "" || username === "" || !isEmailUnique || !isUsernameUnique;

  const isSubmitDisabled = signupByInvite
    ? hasCommonDisabled
    : hasCommonDisabled || password1 === "" || password2 === "";

  return (
    <>
      {!signupByInvite && (
        <CheckboxesContainer style={{ marginTop: "1rem" }}>
          <Checkbox name="is_subscribed" checked={isSubscribed} onChange={toggleSubscribed} />
          <Desc>{t("subscribeToServiceNews")}</Desc>
        </CheckboxesContainer>
      )}
      <CheckboxesContainer style={{ marginBottom: 0 }}>
        <TermsDescription dangerouslySetInnerHTML={{ __html: getMarkdownString(terms) }} />
      </CheckboxesContainer>
      <ButtonsContainer>
        <Link to={ROUTES.SIGN_IN}>{signIn}</Link>
        <WaitingButton
          isWaiting={isWaiting}
          primary
          className="primary-button"
          disabled={isSubmitDisabled}
          onClick={send}
        >
          {signupByInvite ? t("sendRequest") : t("register")}
        </WaitingButton>
      </ButtonsContainer>
      {((error.email && error.email[0]) || error.none_field_errors || error.other) && (
        <ErrorMessage>
          <Description style={{ margin: 0 }}>
            {error.email || error.none_field_errors || error.other}
            {error.email && error.email[0] && (
              <Link to={ROUTES.ACCESS_RECOVERY}>
                <Description style={{ marginBottom: 0 }}> {t("forgotLoginPassword")}</Description>
              </Link>
            )}
          </Description>
        </ErrorMessage>
      )}
    </>
  );
};

export const FormFooter = memo(FormFooterComponent);
